<template>
  <div class="content">
    <center-nav ref="centerNav" @getBuySeatIndex="getBuySeat"></center-nav>
    <!--    有小程序座位席位时且绑定了小程序v-if="seatNum > 0 && openAppList.length > 0 && isAuthorized == 1"-->
    <slider-menu
      :menuData="menuData"
      v-if="seatNum > 0 && openAppList.length > 0"
    ></slider-menu>
    <creditCard v-if="seatNum === 0"></creditCard>

    <!-- v-if="openAppList.length > 0 && isAuthorized == 0" -->
<!--    <authorization-->
<!--      @getBuySeat="getBuySeat"-->
<!--      @openSet="openSet"-->
<!--      v-if="openAppList.length > 0"-->
<!--    ></authorization>-->
<!--    <auto v-if="seatNum > 0 && openAppList.length === 0 && !isAuto" @openSet="openSet"></auto>-->
    <!-- <set v-if="setShow"></set> -->
  </div>
</template>

<script>
import mini from "@/api/mini";
const miniModel = new mini();
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";
import creditCard from "../../pc/channelMiniProgram/creditCard/index";
import authorization from "../../pc/channelMiniProgram/authorization/index";
import pay from "../../pc/channelMiniProgram/pay/index";
import auto from "../../pc/channelMiniProgram/auto/index";
import set from './set/index.vue'
export default {
  components: {
    centerNav, // 头部导航
    sliderMenu, // 侧边栏
    creditCard,
    authorization,
    pay,
    auto,
    set,
  },
  data() {
    return {
      appKeyRoute:'',
      setShow:false,
      seatNum: "", //小程序席位数量
      openAppList: [],
      isAuto: false, //是否授权
      packagePitList: [],
      isAuthorized: 0, // 是否已经绑定商户号
      ipOpenCoupon: false, // 优惠券开关
      menuData: [
        {
          path: "/pc/channelMiniProgram/home",
          icon: "icon-xcx_refresh_home_n_1",
          title: "主页",
          hidden: false,
          iconSize: "16px",
        },
        // {
        //   path: "/pc/channelMiniProgram/user",
        //   icon: "icon-xcx_refresh_user_n_2",
        //   title: "用户列表",
        //   hidden: false,
        //   iconSize: "16px",
        // },
        {
          path: "/pc/channelMiniProgram/order",
          icon: "icon-xcx_refresh_order_n_3",
          title: "影票订单",
          hidden: false,
        },
        // {
        //   path: "/pc/channelMiniProgram/audit",
        //   icon: "icon-xcx_refresh_await_n_5",
        //   title: "提现审核",
        //   hidden: false,
        //   iconSize: "16px",
        // },
        {
          path: "/pc/channelMiniProgram/financialDetails",
          icon: "icon-xcx_refresh_detail_n_6",
          title: "资金明细",
          hidden: false,
          iconSize: "16px",
        },
        // {
        //   path: "/pc/channelMiniProgram/coupon",
        //   icon: "icon-xcx_refresh_detail_n_6",
        //   title: "活动中心",
        //   hidden: false, iconSize: '16px'
        // },
        // {
        //   path: "/pc/channelMiniProgram/coupon",
        //   icon: "icon-xcx_refresh_detail_n_6",
        //   title: "活动中心",
        //   hidden: false,
        //   iconSize: "16px",
        //   children:[]
        // },
        {
          path: "/pc/channelMiniProgram/set",
          icon: "icon-xcx_refresh_set_n_8",
          title: "基础设置",
          hidden: false,
          iconSize: "16px",
        },
        // {
        //   path: "/pc/channelMiniProgram/promotion",
        //   icon: "icon-xcx_refresh_tool_n_7",
        //   title: "推广工具",
        //   iconSize: "16px",
        //   hidden: false,
        //   children: [
        //     {
        //       path: "/pc/channelMiniProgram/promotionManage",
        //       title: "推广位管理",
        //     },
        //     {
        //       path: "/pc/channelMiniProgram/statisticalData",
        //       title: "统计数据",
        //     },
        //   ],
        // },
      ],
    };
  },
  async mounted() {
    console.log('minigrp==222333')
    // var url = location.search;
    // console.log(url,'url=-===1')
    await this.getBuySeat();
    let couponIndex = this.setCouponParams()
    let miniAppTypeChannel = localStorage.getItem('miniAppTypeChannel')
    console.log(miniAppTypeChannel,'miniAppTypeChannel== 3和undefined开启==')
    let appKey = localStorage.getItem('appKeyMini')
    if (this.$route.query.isAuto) {
      this.isAuto = this.$route.query.isAuto;
    }
    if(this.$route.query.appKey) {
      this.appKeyRoute = this.$route.query.appKey
    }
    // await this.getBuySeat();
    // miniAppTypeChannel：1淘宝，2天猫，3抖音，4支付宝，5快手
    // 快手、支付宝、淘宝、天猫、好影抖音影藏 活动中心菜单栏
    // 极光：16045865425测试环境：好影：19235541328正式环境：好影：16663046825
    let couponArr = ['1','2','4','5']
    console.log(couponArr.indexOf(miniAppTypeChannel),'ASD')
    // if(miniAppTypeChannel !== null && couponArr.indexOf(miniAppTypeChannel) === -1){
    //   console.log('AAA==111')
    //   this.getUserCoupon();
    // }else if(miniAppTypeChannel == '3' && appKey == '16045865425') {
    //   console.log('AAA==2222')
    //   this.getUserCoupon();
    // }
    if(miniAppTypeChannel == '4') {
      // 设置活动中心菜单
      // this.setActivityCenter()
    }


    // miniAppTypeChannel：1淘宝，2天猫，3抖音，4支付宝，5快手，禁用菜单“推广工具”
    let miniAppTypeArr = ['1','2','3','4','5']

    console.log(miniAppTypeArr.indexOf(miniAppTypeChannel),'ASD==miniAppTypeChannel')
    console.log(miniAppTypeChannel,'miniAppTypeChannel==')
    if(miniAppTypeChannel !== null && miniAppTypeArr.indexOf(miniAppTypeChannel) === -1) {
      // this.menuData.push({
      //     path: "/pc/channelMiniProgram/promotion",
      //     icon: "icon-xcx_refresh_tool_n_7",
      //     title: "推广工具",
      //     iconSize: "16px",
      //     hidden: false,
      //     children: [
      //       {
      //         path: "/pc/channelMiniProgram/promotionManage",
      //         title: "推广位管理",
      //       },
      //       {
      //         path: "/pc/channelMiniProgram/statisticalData",
      //         title: "统计数据",
      //       },
      //     ],
      //   })
    }else{
      console.log('BBB==')
    }
    // await this.getSet(couponIndex)
    // if(this.menuData[couponIndex].children.length === 0) {
    //   // 删除其中一项
    //   this.menuData.splice(couponIndex, 1);
    // }
  },
  methods: {
    setCouponParams() {
      return  this.menuData.findIndex(item => {
        return item.path === '/pc/channelMiniProgram/coupon'
      })
    },
    async getSet(couponIndex) {
      const res = await miniModel.setMini({
        appKey: localStorage.getItem("appKeyMini"),
      })
      console.log(res,'res======')
      if(res.data.code !== 200) {
        this.$message.error(res.data.message || '获取设置失败Channel')
        return
      }
      let couponItems = this.menuData[couponIndex]
      let data = res.data.data
      let couponTypeList = data.couponType ? data.couponType.split(',').map(Number) : [];
      let miniAppTypeChannel = localStorage.getItem('miniAppTypeChannel')
      if(data.openCoupon) {
        if(miniAppTypeChannel == "4" && couponTypeList.includes(50)) {
          couponItems.children.push(
            {
              path: "/pc/channelMiniProgram/couponGroupNew",
              title: "优惠券新",
            },
            // {
            //   path: "/pc/channelMiniProgram/couponGroup",
            //   title: "优惠券",
            // },
          )
          this.$set(this.menuData, couponIndex, couponItems);
        }
      }
      couponItems.children.push(
        {
          path: "/pc/channelMiniProgram/couponGroup",
          title: "优惠券",
        },
      )
      this.$set(this.menuData, couponIndex, couponItems);
    },
    setActivityCenter() {
      const item = {
        path: "/pc/channelMiniProgram/coupon",
        icon: "icon-xcx_refresh_detail_n_6",
        title: "活动中心",
        hidden: false,
        iconSize: "16px",
        children: [
          {
            path: "/pc/channelMiniProgram/couponGroup",
            title: "优惠券",
          },
          {
            path: "/pc/channelMiniProgram/couponGroupNew",
            title: "优惠券新",
          },
        ],
      };
      let arr = this.menuData;
      arr.splice(5, 0, item);
      this.menuData = [...arr];
    },
    openSet() {
      this.isAuthorized = 1
      this.$router.push({
        path:'/pc/channelMiniProgram/set'
      })
      // this.setShow = true
      console.log('openSetopenSet')
    },
    // 获取优惠券开关
    getUserCoupon() {
      miniModel
        .userCoupon({
          appKey: localStorage.getItem("appKeyMini"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            console.log('获取优惠券开关菜单==',res)
            console.log(res.data.data.isOpenCoupon,'后台是否开启优惠券菜单权限')
            this.$store.commit("nav/SET_ISOPEN_DOUYIN", res.data.data.isDy);
            const item = {
              path: "/pc/channelMiniProgram/coupon",
              icon: "icon-xcx_refresh_detail_n_6",
              title: "活动中心",
              hidden: false,
              iconSize: "16px",
            };
            if (res.data.data.isOpenCoupon == 1) {
              let arr = this.menuData;
              arr.splice(5, 0, item);
              this.menuData = [...arr];
            }
            // let arr = this.menuData;
            //   arr.splice(5, 0, item);
            //   this.menuData = [...arr];
          }
        });
    },
    // 获取购买席位数量
    async getBuySeat(appKey) {
      let params = {
        // client:4
        channelType:7
      }
      await miniModel.getMiniNum(params).then((res) => {
        console.log(res,'获取购买席位数量22222');
        if (res.data.code == 200) {
          this.seatNum = res.data.data.openAppList.length;
          this.packagePitList = res.data.data.packagePitList;
          this.openAppList = res.data.data.openAppList;

          if(this.openAppList.length == 0) return
          console.log('openAppList有数据Channel')
          // 设置缓存
          let miniActiveChannel = localStorage.getItem('miniActiveChannel')
          if(miniActiveChannel === null) {
            console.log('VVV=111==miniActive为null')
            // 取第一个
            this.isAuthorized = this.openAppList[0].isAuthorized;
            localStorage.setItem('isAuthorized',this.openAppList[0].isAuthorized)
            localStorage.setItem('miniAppTypeChannel', this.openAppList[0].miniAppType)
            localStorage.setItem('miniActiveChannel',0)
            // appkey
            localStorage.setItem('appKeyMini',this.openAppList[0].appKey)
            // id
            localStorage.setItem('appIdChannel',this.openAppList[0].id)
            localStorage.setItem('appName',this.openAppList[0].appName)
          }else{
            if(this.openAppList[miniActiveChannel]) {
              this.isAuthorized = this.openAppList[miniActiveChannel].isAuthorized;
              localStorage.setItem('isAuthorized',this.openAppList[miniActiveChannel].isAuthorized)
              localStorage.setItem('miniAppTypeChannel', this.openAppList[miniActiveChannel].miniAppType)
              // localStorage.setItem('miniActiveChannel',0)
              // appkey
              localStorage.setItem('appKeyMini',this.openAppList[miniActiveChannel].appKey)
              // id
              localStorage.setItem('appIdChannel',this.openAppList[miniActiveChannel].id)
              localStorage.setItem('appName',this.openAppList[miniActiveChannel].appName)
            }else{
              // 取第一个
              this.isAuthorized = this.openAppList[0].isAuthorized;
              localStorage.setItem('isAuthorized',this.openAppList[0].isAuthorized)
              localStorage.setItem('miniAppTypeChannel', this.openAppList[0].miniAppType)
              localStorage.setItem('miniActiveChannel',0)
              // appkey
              localStorage.setItem('appKeyMini',this.openAppList[0].appKey)
              // id
              localStorage.setItem('appIdChannel',this.openAppList[0].id)
              localStorage.setItem('appName',this.openAppList[0].appName)
            }

          }
          if (appKey != undefined) {
            console.log('授权资质AA11')
            for (let index in this.openAppList) {
              if (this.openAppList[index].appKey == appKey) {
                this.isAuthorized = this.openAppList[index].isAuthorized;
                localStorage.setItem(
                  "isAuthorized",
                  this.openAppList[index].isAuthorized
                );
              }
            }
          } else {
            console.log('授权资质BB11')
            if (localStorage.getItem("isAuthorized")) {
              console.log('授权资质BB11==1')
              this.isAuthorized = localStorage.getItem("isAuthorized");
            } else {
              console.log('授权资质BB11==2')
              if (this.openAppList.length > 0) {
                this.isAuthorized = this.openAppList[0].isAuthorized;
              }
            }
            console.log(this.$route.query.appKey,'this.$route.query.appKey')
            // 授权页面传值，选中对应项
            if(this.$route.query.appKey){
              console.log('有传appkey')
              for (let index in this.openAppList) {
                console.log('循环')
                // appkey相同
                if(this.openAppList[index].appKey == this.$route.query.appKey) {
                  this.isAuthorized = this.openAppList[index].isAuthorized;
                  localStorage.setItem('isAuthorized',this.openAppList[index].isAuthorized)
                  localStorage.setItem('miniActiveChannel',index)
                  // appkey
                  localStorage.setItem('appKeyMini',this.$route.query.appKey)
                  // id
                  localStorage.setItem('appIdChannel',this.openAppList[index].id)
                  localStorage.setItem('miniAppTypeChannel',this.openAppList[index].miniAppType)
                  localStorage.setItem('appName',this.openAppList[index].appName)
                  console.log(index,'index===56有传appkey的索引',this.openAppList[index])
                }
              }
            }
            if (localStorage.getItem("appIdChannel") != null) {
              console.log('授权资质BB11==3')
              const appIdChannel = localStorage.getItem("appIdChannel");
              for (let index in this.openAppList) {
                if (this.openAppList[index].id == appIdChannel) {
                  this.isAuthorized = this.openAppList[index].isAuthorized;
                  this.appKey = this.openAppList[index].appKey;

                  localStorage.setItem('miniActiveChannel',index)
                  localStorage.setItem('appName',this.openAppList[index].appName)
                  // localStorage.setItem('miniActiveChannel',3)
                  console.log(index,'index=getItem("appIdChannel")')
                  break;
                } else {
                  this.isAuthorized = this.openAppList[0].isAuthorized;
                  this.appKey = this.openAppList[0].appKey;
                }
              }
              console.log(appIdChannel,this.appKey,this.isAuthorized,'getItem("appIdChannel")')
            }
          }
          this.$refs.centerNav.getBuySeat();
          console.log(
            "debug:________________this.isMerchant______________",
            this.isAuthorized
          );
          // if (this.$refs.router != undefined) {
          //   this.$refs.router.getBuySeat()
          // }
        } else {
          this.$message.error(res.data.info);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/index.vue